export default "__VITE_ASSET__DdJ8jahl__"